import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';
import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

export function PatternsFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;
  onApplySearchFilters: () => void;
  onFilterUpdate: (value: string[]) => void;
  toggleFilterOptions: () => void;
}) {
  const { t } = useTranslation('filters');
  const [filterOptions, setFilterOptions] = useState([] as MappedFacet[]);
  const [selectedPatterns, setSelectedPatterns] = useState([] as string[]);

  useEffect(() => {
    if (!filter || !filter?.options?.length) return;

    const selectedPatterns = filter.options.filter((option) => option.checked).map((option) => option.value);
    setFilterOptions(filter.options);
    setSelectedPatterns(selectedPatterns);
  }, [filter?.options]);

  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter || !filter?.options?.length) return null;

  function onPatternSelect(id: string) {
    if (selectedPatterns.includes(id)) {
      const newSelectedPattern = selectedPatterns.filter((pattern) => pattern !== id);
      setSelectedPatterns(newSelectedPattern);
      onFilterUpdate(newSelectedPattern);
    } else {
      setSelectedPatterns([...selectedPatterns, id]);
      onFilterUpdate([...selectedPatterns, id]);
    }
  }

  return (
    <div
      key={filter.name}
      className={clsx(styles.filterDefaultZIndex, 'position-relative')}
      style={{
        zIndex: 2,
      }}>
      <div
        onClick={toggleFilterOptions}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedPatterns.length && (
          <span className={`${styles.filtercounter}`}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedPatterns.length}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {isActive && (
        <div className={`position-absolute bg-white border border-dark p-2 filter-list`} style={{ top: '35px' }}>
          <div className={`d-flex flex-wrap ${styles.patternsContainer}`} style={{ gap: '0.3rem', paddingBottom: 1 }}>
            {filterOptions.map((option) => (
              <div
                onClick={() => onPatternSelect(option.id)}
                key={option.id}
                className="d-flex align-items-center mb-2 w-100"
                style={{ fontSize: '0.775rem' }}>
                <input
                  className="cursor-pointer"
                  name="patterns"
                  type="checkbox"
                  checked={selectedPatterns.includes(option.id)}
                  onChange={() => {}}
                  style={{ display: 'initial', accentColor: 'transparent' }}
                />
                <label
                  className={clsx(`ms-2 cursor-pointer me-3`, styles.patternOption, option.checked ? 'fw-bold' : '')}>
                  <span className={'me-2'}>{option.name}</span>
                  <span className={styles['filter-badge-gray']}>{option.count}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="position-relative">
            <button
              onClick={onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
